var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProfileIconPrimary(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 101,
    height: 100,
    viewBox: "0 0 101 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M83.8334 87.5C83.8334 81.6851 83.8334 78.7777 83.1157 76.4119C81.4998 71.0852 77.3315 66.9168 72.0048 65.301C69.639 64.5833 66.7315 64.5833 60.9167 64.5833H40.0834C34.2685 64.5833 31.3611 64.5833 28.9953 65.301C23.6686 66.9168 19.5002 71.0852 17.8844 76.4119C17.1667 78.7777 17.1667 81.6851 17.1667 87.5M69.25 31.25C69.25 41.6053 60.8554 50 50.5 50C40.1447 50 31.75 41.6053 31.75 31.25C31.75 20.8947 40.1447 12.5 50.5 12.5C60.8554 12.5 69.25 20.8947 69.25 31.25Z",
    stroke: "#1D2939",
    strokeWidth: 5.67,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileIconPrimary);
export default __webpack_public_path__ + "static/media/profile-icon-primary.010700821f6ce7c047bd59885450aaf6.svg";
export { ForwardRef as ReactComponent };